import { formatPhoneNumberIntl, isValidPhoneNumber, Value } from 'react-phone-number-input';
import { z } from 'zod';

export const phoneNumberSchema = z
  .string()
  .trim()
  .nonempty()
  .refine(
    (val) => {
      if (val) {
        return isValidPhoneNumber(val);
      } else {
        return true;
      }
    },
    {
      message: 'Please provide a valid phone number.',
    }
  )
  .transform((val) => {
    if (val) {
      return formatPhoneNumberIntl(val as Value);
    }
    return val;
  });
